import { Component, OnInit } from '@angular/core';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.css']
})
export class ModalErrorComponent implements OnInit {

  mensaje: string = '';
  icono:string = 'bi bi-x-octagon-fill icono-error';
  titulo:string = 'Error';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onClickDismiss(event:Event, res:string):void{
    this.modal.dismiss(res);
  };

}
